module.exports = __webpack_public_path__ + "img/play-game.e989f207.png";